var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEstateOldIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 122,
    viewBox: "0 0 176 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illus-bienancien"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arbre"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 48",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.6 120.734C139.763 120.397 119.585 101.727 131.106 97.7897C142.628 93.8521 140.137 83.0078 146.408 83.9481C152.68 84.8885 158.968 90.9016 158.931 94.8391C158.893 98.7767 162.891 98.0179 162.891 103.427C162.891 107.548 157.81 116.107 152.159 119.891C150.394 121.072 145.751 120.814 144.6 120.734Z",
    fill: "#92C281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 48_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8943 120.734C40.7315 120.397 60.9096 101.727 49.388 97.7897C37.8665 93.8521 40.3573 83.0078 34.086 83.9481C27.8148 84.8885 21.5261 90.9016 21.5638 94.8391C21.6015 98.7767 17.6032 98.0179 17.6032 103.427C17.6032 107.548 22.6841 116.107 28.3358 119.891C30.1001 121.072 34.7435 120.814 35.8943 120.734Z",
    fill: "#92C281"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M3.0001 119H173",
    stroke: "#120136",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3722 11.6079L72.8742 5.45188C77.2482 3.18388 81.6222 1.72588 85.9962 1.56388C87.6162 1.40188 89.2362 1.40188 90.6942 1.56388C95.0682 1.88788 99.6042 3.18388 103.816 5.45188L115.318 11.6079V16.4679L105.436 11.1219C100.738 8.52988 95.8782 7.07188 90.8562 6.90988C90.0462 6.90988 89.0742 6.90988 88.2642 6.90988C87.4542 6.90988 86.4822 6.90988 85.6722 6.90988C80.8122 7.23388 75.9522 8.69188 71.0922 11.1219L61.2102 16.4679L61.3722 11.6079Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.612 33.3154V38.9854H109.212V33.3154C109.212 33.3154 141.612 33.3154 141.612 33.3154Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7941 114.87H78.0581V96.8701H98.7941V114.87Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.612 120.733H35.24V115.063H149.774L149.612 120.733Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.24 33.3154H67.802V38.9854H35.24V33.3154Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1001 38.2256H67.6401V48.5936V61.0676V71.1116L67.4781 83.5856V92.1716C67.4781 92.3336 67.4781 92.4956 67.6401 92.6576V93.4676V105.942V115.824H40.1001V38.2256Z",
    fill: "#F6AA5A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M109.212 115.986V106.104L109.212 93.6296V92.4956C109.212 92.3336 109.374 92.1716 109.374 92.0096V83.4236L109.212 70.9496V61.0676V48.5936V38.2256H136.752V115.986H109.212Z",
    fill: "#F6AA5A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8741 9.87571C77.2481 7.60771 81.6221 6.14971 85.9961 5.98771C87.6161 5.82571 89.2361 5.82571 90.6941 5.98771C95.0681 6.31171 99.6041 7.60771 103.816 9.87571L109.81 13.1157V115.986H101.872V101.73V95.2497C101.872 94.2777 101.224 93.6297 100.252 93.6297H76.4381C75.4661 93.6297 74.8181 94.2777 74.8181 95.2497V101.73V115.986H66.8801V13.1157L72.8741 9.87571Z",
    fill: "#FFDE86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.928 61.0677H76.276C75.466 61.0677 74.656 60.2578 74.656 59.4478V59.2857V59.1237V50.2138C74.656 49.2418 75.304 48.5938 76.276 48.5938H99.928C100.252 48.5938 100.576 48.7558 100.9 48.9178C101.548 49.0798 102.034 49.7277 102.034 50.3757V59.1237C102.034 59.9338 101.386 60.5817 100.738 60.7437C100.576 60.9057 100.252 61.0677 99.928 61.0677ZM94.258 57.8278H98.956V51.8338H94.258V57.8278ZM90.856 57.8278H85.996V51.8338H90.856V57.8278ZM77.896 57.8278H82.756V51.8338H77.896V57.8278Z",
    fill: "#1E1548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9561 57.828H94.2581V51.834H98.9561V57.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8561 57.828H85.9961V51.834H90.8561V57.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.756 57.828H77.896V51.834H82.756V57.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.928 83.2621H76.276C75.466 83.2621 74.656 82.6141 74.656 81.6421V81.4801V81.3181V72.4081C74.656 71.4361 75.304 70.7881 76.276 70.7881H99.928C100.252 70.7881 100.576 70.9501 100.9 71.1121C101.548 71.2741 102.034 71.9221 102.034 72.5701V81.3181C102.034 82.1281 101.386 82.7761 100.738 82.9381C100.576 83.1001 100.252 83.2621 99.928 83.2621ZM94.258 80.0221H98.956V74.0281H94.258V80.0221ZM90.856 80.0221H85.996V74.0281H90.856V80.0221ZM77.896 80.0221H82.756V74.0281H77.896V80.0221Z",
    fill: "#1E1548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9561 80.0223H94.2581V74.0283H98.9561V80.0223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8561 80.0223H85.9961V74.0283H90.8561V80.0223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.756 80.0223H77.896V74.0283H82.756V80.0223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fenetre"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.928 37.9017H76.276C75.466 37.9017 74.656 37.2537 74.656 36.2817V36.1197V35.9577V27.0477C74.656 26.0757 75.304 25.4277 76.276 25.4277H99.928C100.252 25.4277 100.576 25.5897 100.9 25.7517C101.548 25.9137 102.034 26.5617 102.034 27.2097V35.9577C102.034 36.7677 101.386 37.4157 100.738 37.5777C100.576 37.7397 100.252 37.9017 99.928 37.9017ZM94.258 34.6617H98.956V28.6677H94.258V34.6617ZM90.856 34.6617H85.996V28.6677H90.856V34.6617ZM77.896 34.6617H82.756V28.6677H77.896V34.6617Z",
    fill: "#1E1548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.756 34.662H77.896V28.668H82.756V34.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8561 34.662H85.9961V28.668H90.8561V34.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9561 34.662H94.2581V28.668H98.9561V34.662Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9561 50.662H58.2581V44.668H62.9561V50.662Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8561 50.662H49.9961V44.668H54.8561V50.662Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.756 50.662H41.896V44.668H46.756V50.662Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9561 70.662H58.2581V64.668H62.9561V70.662Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8561 70.662H49.9961V64.668H54.8561V70.662Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.756 70.662H41.896V64.668H46.756V70.662Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9561 90.662H58.2581V84.668H62.9561V90.662Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8561 90.662H49.9961V84.668H54.8561V90.662Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.756 90.662H41.896V84.668H46.756V90.662Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.956 90.662H130.258V84.668H134.956V90.662Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.856 90.662H121.996V84.668H126.856V90.662Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.756 90.662H113.896V84.668H118.756V90.662Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.956 70.662H130.258V64.668H134.956V70.662Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.856 70.662H121.996V64.668H126.856V70.662Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.756 70.662H113.896V64.668H118.756V70.662Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.956 50.662H130.258V44.668H134.956V50.662Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.856 50.662H121.996V44.668H126.856V50.662Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.756 50.662H113.896V44.668H118.756V50.662Z",
    fill: "#B55436"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstateOldIcon);
export default __webpack_public_path__ + "static/media/estate-old-icon.81d2771a.svg";
export { ForwardRef as ReactComponent };